import { render, staticRenderFns } from "./package-contacts-widget.vue?vue&type=template&id=535e8e99&"
import script from "./package-contacts-widget.vue?vue&type=script&lang=js&"
export * from "./package-contacts-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports